module.exports = __webpack_public_path__ + "images/file_icons_v2/mov-98e006755a6da9a5f5d97f549c4f12ca.svg";